var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatnership(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Handshake",
    clipPath: "url(#clip0_26049_15314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.583 23.75L25.333 30L15.333 27.5L6.58301 21.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6895 11.0359L20.3332 8.75L28.977 11.0359",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.7035 9.44057L1.716 17.4187C1.5678 17.715 1.54332 18.0581 1.64791 18.3724C1.75251 18.6868 1.97763 18.9468 2.27381 19.0953L6.58318 21.2499L11.6894 11.0359L7.38162 8.88276C7.23482 8.80914 7.07495 8.76517 6.91115 8.75336C6.74734 8.74155 6.58282 8.76213 6.42697 8.81394C6.27113 8.86574 6.12702 8.94775 6.00288 9.05527C5.87875 9.16279 5.77701 9.29372 5.7035 9.44057Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M34.0828 21.2499L38.3922 19.0953C38.6884 18.9468 38.9135 18.6868 39.0181 18.3724C39.1227 18.0581 39.0982 17.715 38.95 17.4187L34.9625 9.44057C34.889 9.29372 34.7873 9.16279 34.6631 9.05527C34.539 8.94775 34.3949 8.86574 34.239 8.81394C34.0832 8.76213 33.9187 8.74155 33.7548 8.75336C33.591 8.76517 33.4312 8.80914 33.2844 8.88276L28.9766 11.0359L34.0828 21.2499Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.0827 11.25H22.8327L15.6984 18.1703C15.5657 18.3029 15.4646 18.4636 15.4025 18.6405C15.3405 18.8174 15.319 19.0061 15.3397 19.1925C15.3604 19.3788 15.4228 19.5582 15.5222 19.7171C15.6216 19.8761 15.7555 20.0107 15.914 20.1109C18.6499 21.8594 22.364 21.7391 25.3327 18.75L31.5827 23.75L34.0827 21.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.7174 33.75L13.1986 32.1203L9.08301 29.1797",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26049_15314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatnership);
export default __webpack_public_path__ + "static/media/Patnership.3b766f52c234b81946a431669e045ebb.svg";
export { ForwardRef as ReactComponent };